"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  height: ", ";\n  width: ", ";\n"], ["\n  height: ", ";\n  width: ", ";\n"])), function (_a) {
    var size = _a.size;
    return "".concat(size, "px");
}, function (_a) {
    var size = _a.size;
    return "".concat(size, "px");
});
var Inner = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  height: 100%;\n  width: 100%;\n  animation: rotate 1s infinite linear;\n  border: ", ";\n  border-right-color: transparent;\n  border-radius: 50%;\n\n  @keyframes rotate {\n    0% {\n      transform: rotate(360deg);\n    }\n    100% {\n      transform: rotate(0deg);\n    }\n  }\n"], ["\n  height: 100%;\n  width: 100%;\n  animation: rotate 1s infinite linear;\n  border: ", ";\n  border-right-color: transparent;\n  border-radius: 50%;\n\n  @keyframes rotate {\n    0% {\n      transform: rotate(360deg);\n    }\n    100% {\n      transform: rotate(0deg);\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme, size = _a.size, color = _a.color;
    return "".concat(size / 6.5, "px solid ").concat(color !== null ? color : theme.color.primary);
});
var Loader = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'm' : _b, className = _a.className, color = _a.color;
    var sizeMapping = {
        m: 16,
        l: 24,
        xl: 40,
        xxl: 110
    };
    var sizeName = size in sizeMapping ? sizeMapping[size] : 16;
    return (react_1["default"].createElement(Wrapper, { className: className, size: sizeName },
        react_1["default"].createElement(Inner, { size: sizeName, color: color })));
};
exports["default"] = Loader;
var templateObject_1, templateObject_2;
